import { CartUpdateResult, type LineItem } from "@app/scripts/types";
import React, { useCallback, useEffect, useState } from "react";

type Props = {
  lineItem: LineItem;
  onQtyChange: (value: number) => Promise<CartUpdateResult>;
  oos?: boolean;
  isKid?: boolean;
};

export const CartQty: React.FC<Props> = ({ lineItem, onQtyChange, oos, isKid }) => {
  const [value, setValue] = useState(lineItem.quantity);

  const handleChange = useCallback(
    async (newVal: number) => {
      const oldVal = value;
      setValue(newVal);
      const result = await onQtyChange(newVal);

      if (result?.error) {
        setValue(oldVal);
      }
    },
    [value, onQtyChange]
  );

  useEffect(() => {
    setValue(lineItem?.quantity);
  }, [lineItem]);

  return (
    <div className={`_field qty ${oos && isKid ? "hidden" : ""} flex-1`}>
      <input type="number" value={value} onChange={(e) => handleChange(parseInt(e.target.value))} />
      <button tabIndex={-1} onClick={() => handleChange(value - 1)}>
        <div className="qty-btn-wrap">
          <ui-icon name="icon-minus" />
        </div>
      </button>
      <button tabIndex={-1} onClick={() => handleChange(value + 1)}>
        <div className="qty-btn-wrap">
          <ui-icon name="icon-plus" />
        </div>
      </button>
    </div>
  );
};
